import { animate, stagger } from 'motion';

// Animate modal show
export const animateModalShow = (modalContainer) => {
  if (!modalContainer) return;

  animate(
    modalContainer,
    { opacity: [0, 1], scale: [0.95, 1] },
    { duration: 0.2, easing: 'ease-out' }
  );
};

// Animate modal hide
export const animateModalHide = (modalContainer) => {
  if (!modalContainer) return Promise.resolve();

  return animate(
    modalContainer,
    { opacity: [1, 0], scale: [1, 0.95] },
    { duration: 0.15, easing: 'ease-in' }
  ).finished;
};

// Animate note list items (staggered entrance)
export const animateNoteListItems = (container) => {
  if (!container) return;

  const items = container.querySelectorAll('note-item, .note-list-mobile-card');
  if (items.length === 0) return;

  animate(
    items,
    { opacity: [0, 1], y: [10, 0] },
    { duration: 0.3, delay: stagger(0.05), easing: 'ease-out' }
  );
};

// Animate mobile detail slide in
export const animateMobileDetailShow = (element) => {
  if (!element) return;

  animate(element, { x: ['100%', '0%'] }, { duration: 0.25, easing: [0.32, 0.72, 0, 1] });
};

// Animate mobile detail slide out
export const animateMobileDetailHide = (element) => {
  if (!element) return Promise.resolve();

  return animate(element, { x: ['0%', '100%'] }, { duration: 0.2, easing: [0.32, 0.72, 0, 1] })
    .finished;
};
